import { ColorBadge } from "@legacy-components/ColorBadge/ColorBadge";
import { ColTypeDef, ICellRendererParams } from "ag-grid-community";
import { GridInlineThumbnailCell } from "../CustomRenders/GridInlineThumbnailCell";
import { ActionsCell } from "./ActionsCell";
import { NullValueCell } from "./NullValueCell";
import { valueFormatters } from "./ValueFormatters";

export const columnTypes: { [key: string]: ColTypeDef<unknown> } = {
  //-------------------------------------------------------------------------
  status: {
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <ColorBadge
          text={params.data.dsStatus}
          semanticValue={params.data.cdSemanticValue}
        />
      );
    },
  },
  //-------------------------------------------------------------------------
  link: {
    cellRenderer: (params: ICellRendererParams) => {
      const text = params.value;
      const linkField = params.colDef?.cellRendererParams?.linkField;
      const url = linkField && params.data ? params.data[linkField] : undefined;
      if (!text || !url) return <NullValueCell />;
      return <a href={url}>{text}</a>;
    },
  },
  //-------------------------------------------------------------------------
  doubleLine: {
    cellRenderer: (params: ICellRendererParams) => {
      if (!params.data) return <NullValueCell />;

      const p = params.colDef?.cellRendererParams;

      const buildLabel = (fields: string[] | undefined, fallback: unknown) => {
        if (!fields?.length) return fallback != null ? String(fallback) : undefined;
        const [f1, f2, f3] = fields;
        const v1 = params.data[f1];
        const v2 = f2 != null ? params.data[f2] : null;
        if (v1 == null) return undefined;
        let label = String(v1);
        if (v2 != null) label += ", " + String(v2);
        const v3 = f3 != null ? params.data[f3] : null;
        if (v3 != null) label += " (" + String(v3) + ")";
        return label;
      };

      const title = buildLabel(p?.titleFields, params.value);
      const subtitleField = p?.subtitleField;
      const subtitle = p?.subtitleFields?.length
        ? buildLabel(p.subtitleFields, undefined)
        : subtitleField
          ? params.data[subtitleField]
          : undefined;

      return (
        <div className="double-line-cell">
          <div className="double-line-title">{title}</div>
          <div className="double-line-subtitle">{subtitle}</div>
        </div>
      );
    },
  },
  //-------------------------------------------------------------------------
  datetime: {
    valueFormatter: valueFormatters.datetime,
  },
  //-------------------------------------------------------------------------
  currency: {
    valueFormatter: valueFormatters.currency,
    headerClass: "ag-header-cell-right",
    cellClass: "ag-cell-right",
  },
  //-------------------------------------------------------------------------
  number: {
    valueFormatter: valueFormatters.number,
    headerClass: "ag-header-cell-right",
    cellClass: "ag-cell-right",
  },
  //-------------------------------------------------------------------------
  text: {
    //
  },
  actions: {
    suppressNavigable: true,
    sortable: false,
    filter: false,
    resizable: false,
    cellClass: "ag-cell-right no-border-focus",
    headerClass: "ag-header-cell-right",
    cellRenderer: (params: ICellRendererParams) => {
      return <ActionsCell idObject={params.value} path={params.colDef?.context?.path} />;
    },
  },
  //-------------------------------------------------------------------------
  "inline-thumbnail": {
    sortable: false,
    filter: false,
    cellRenderer: GridInlineThumbnailCell,
  },
  //-------------------------------------------------------------------------
};
